// @ts-check
// Página /campaigns (spec-2.0.0 seção 4.10, [BASE 2.5] regra 2; contrato 09 de campanhas base): leva à primeira tela de
// campanha que o papel abre (e-mail, WhatsApp, fluxos e, por último, Modelos); sem nenhuma, mostra "sem acesso". O
// link das novidades da 1.10.0 e os favoritos antigos para /campaigns continuam abrindo por aqui.
import { html } from 'htm/preact';
import { useEffect } from 'preact/hooks';
import { locationState, navigate } from '../../app/router.js';
import { hasCurrentPermissionFlag } from '../../data/metadata-store.js';
import { firstCampaignScreenPath } from '../../../../shared/navigation/screen-access.js';
import { legacyEmailCampaignPath } from '../../lib/campaign-links.js';
import { CampaignsNoAccess } from './campaigns-no-access.js';

export function CampaignsLanding() {
  const target = firstCampaignScreenPath(hasCurrentPermissionFlag);
  useEffect(() => {
    if (!target) return;
    const { search, hash } = locationState.value;
    navigate(`${target}${search}${hash}`, { replace: true });
  }, [target]);
  if (!target) return html`<${CampaignsNoAccess} screenKey="home" />`;
  return null;
}

/** Redireciona o link antigo /campaigns/<id> para /campaigns/email/<id>. @param {{ campaignId: string }} props */
export function LegacyEmailCampaignRedirect({ campaignId }) {
  useEffect(() => {
    navigate(legacyEmailCampaignPath(campaignId, locationState.value), { replace: true });
  }, [campaignId]);
  return null;
}
